"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _FieldSearch = require("customer-data-objects/search/FieldSearch");

var _immutable = require("immutable");

var _memoizeLast = _interopRequireDefault(require("transmute/memoizeLast"));

var _map = _interopRequireDefault(require("transmute/map"));

var _OptionTypes = require("UIComponents/types/OptionTypes");

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var _react = _interopRequireWildcard(require("react"));

var _reactImmutableProptypes = require("react-immutable-proptypes");

var _ReferenceInputEnumAll = _interopRequireDefault(require("./enum/ReferenceInputEnumAll"));

var _ReferenceInputEnumNone = _interopRequireDefault(require("./enum/ReferenceInputEnumNone"));

var _ReferenceInputEnumSearch = _interopRequireDefault(require("./enum/ReferenceInputEnumSearch"));

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _SyntheticEvent = _interopRequireDefault(require("UIComponents/core/SyntheticEvent"));

var _toJS = _interopRequireDefault(require("transmute/toJS"));

var _translate = _interopRequireDefault(require("transmute/translate"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _propertyTranslator = require("property-translator/propertyTranslator");

var toSelectOptions = (0, _pipe.default)((0, _map.default)((0, _translate.default)({
  help: function help(property) {
    return property.hubspotDefined ? (0, _propertyTranslator.propertyDescriptionTranslator)(property.label, property.description) : property.description;
  },
  text: function text(property) {
    return property.hubspotDefined ? (0, _propertyTranslator.propertyLabelTranslator)(property.label) : property.label;
  },
  value: true
})), _toJS.default);
var propTypes = {
  multi: _react.PropTypes.bool,
  onChange: _react.PropTypes.func.isRequired,
  options: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_OptionTypes.OptionType.isRequired).isRequired, (0, _reactImmutableProptypes.listOf)((0, _reactImmutableProptypes.recordOf)({
    label: _react.PropTypes.string.isRequired,
    value: _react.PropTypes.string.isRequired
  })).isRequired]).isRequired,
  resolver: _ReferenceResolverType.default,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, (0, _reactImmutableProptypes.listOf)(_react.PropTypes.string.isRequired)])
};
var defaultProps = {
  options: []
};

var ReferenceInputEnum =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ReferenceInputEnum, _Component);

  function ReferenceInputEnum() {
    var _this;

    (0, _classCallCheck2.default)(this, ReferenceInputEnum);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReferenceInputEnum).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.makeFuzzyRegExp = (0, _memoizeLast.default)(_FieldSearch.makeFuzzyRegExp);
    return _this;
  }

  (0, _createClass2.default)(ReferenceInputEnum, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options;

      if (!options || Array.isArray(options)) {
        return options;
      }

      return toSelectOptions(options);
    }
  }, {
    key: "getReferenceEnumComponent",
    value: function getReferenceEnumComponent() {
      var resolver = this.props.resolver;

      if (!resolver) {
        return _ReferenceInputEnumNone.default;
      }

      if (resolver.search) {
        return _ReferenceInputEnumSearch.default;
      }

      return _ReferenceInputEnumAll.default;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _this$props = this.props,
          multi = _this$props.multi,
          value = _this$props.value;

      if (multi) {
        return value ? value.toArray() : [];
      }

      return value;
    }
  }, {
    key: "handleChange",
    value: function handleChange(evt) {
      var _this$props2 = this.props,
          multi = _this$props2.multi,
          onChange = _this$props2.onChange;

      if (multi) {
        onChange((0, _SyntheticEvent.default)((0, _immutable.List)(evt.target.value)));
        return;
      }

      onChange(evt);
    }
  }, {
    key: "handleFilterOption",
    value: function handleFilterOption(option, query) {
      var fuzzy = this.makeFuzzyRegExp(query);
      return fuzzy.test(option.text) || option.help && fuzzy.test(option.help);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var ReferenceEnum = this.getReferenceEnumComponent();
      var transferableProps = (0, _omit.default)(['isInline', 'getProperty', 'objectType', 'onInvalidProperty', 'propertyIndex', 'readOnlySourceData', 'showError', 'showPlaceholder', 'subjectId', 'secondaryChanges', 'onSecondaryChange'], this.props);
      return _react.default.createElement(ReferenceEnum, (0, _extends2.default)({}, transferableProps, {
        anchorType: "button",
        filterOption: this.handleFilterOption,
        ignoreAccents: false,
        onChange: this.handleChange,
        options: this.getOptions(),
        ref: function ref(component) {
          return _this2.input = component;
        },
        value: this.getValue()
      }));
    }
  }]);
  return ReferenceInputEnum;
}(_react.Component);

exports.default = ReferenceInputEnum;
ReferenceInputEnum.propTypes = propTypes;
ReferenceInputEnum.defaultProps = defaultProps;
module.exports = exports.default;